import type {
  BomExclusionsResponse,
  CreateRoomRequest,
  ListRoomsResponse,
  RoomListItem,
  UpdateRoomRequest,
} from '@kreart/shared';
import { api } from '@/lib/api';

export const roomsApi = {
  list: (projectId: string) => api.get<ListRoomsResponse>(`/projects/${projectId}/rooms`),
  create: (projectId: string, body: CreateRoomRequest) =>
    api.post<RoomListItem>(`/projects/${projectId}/rooms`, body),
  update: (projectId: string, id: string, body: UpdateRoomRequest) =>
    api.patch<RoomListItem>(`/projects/${projectId}/rooms/${id}`, body),
  remove: (projectId: string, id: string) => api.delete<void>(`/projects/${projectId}/rooms/${id}`),
  copy: (projectId: string, id: string) =>
    api.post<RoomListItem>(`/projects/${projectId}/rooms/${id}/copy`),

  /** BOM rows this room excludes from the detailed offer PDF ("<entityType>:<entityId>" keys). */
  getBomExclusions: (projectId: string, roomId: string) =>
    api.get<BomExclusionsResponse>(`/projects/${projectId}/rooms/${roomId}/bom-exclusions`),
  setBomExclusions: (
    projectId: string,
    roomId: string,
    excludedKeys: string[],
    includedKeys: string[],
  ) =>
    api.put<BomExclusionsResponse>(`/projects/${projectId}/rooms/${roomId}/bom-exclusions`, {
      excludedKeys,
      includedKeys,
    }),
};
